import { baseApi } from "./apiConfig.js";
import { store } from "@/store/store";
import { persistor } from "@/store/store";
import { setAuthData, clearAuthData, setAuthenticated } from "@/redux/auth/authSlice";

export const getStateLists = async () => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.get(`/portal/stateLists?_=${timestamp}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching state lists:", error);
    throw error;
  }
};

export const getCitiesByState = async (stateCode) => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.get(
      `/portal/lean-regn/cityListForState?state=${stateCode}&_=${timestamp}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching cities:", error);
    throw error;
  }
};

export const getUserProfile = async () => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.get(
      `/portal/lean-regn/getUserProfile?${timestamp}&_=${timestamp}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    throw error;
  }
};

export const getBrokerAffiliateNames = async () => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.get(
      `/portal/broker-affiliates?_=${timestamp}`
    );
    return {
      status: "SUCCESS",
      data: response.data || []
    };
  } catch (error) {
    console.error("Error fetching broker affiliate names:", error);
    return {
      status: "ERROR",
      data: [],
      error: error.message
    };
  }
};

export const updateUserLicense = async (licenseData) => {
  try {
    const response = await baseApi.post(
      "/portal/user/updateLicense",
      licenseData
    );
    return response.data;
  } catch (error) {
    console.error("Error updating license:", error);
    throw error;
  }
};

export const getAllLicenseDetails = async () => {
  try {
    const response = await baseApi.post("/portal/lean-regn/allLicenceDetails");
    return response.data;
  } catch (error) {
    console.error("Error fetching all license details:", error);
    throw error;
  }
};

//Delete License
export const deleteLicense = async (licenseId) => {
  try {
    const response = await baseApi.post(
      `/portal/user/deleteLicense?licenseId=${licenseId}`,
      {
        data: {
          currLicenseId: licenseId,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting license:", error);
    throw error;
  }
};

export const checkPhoneNumberInUse = async (phoneNumber) => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.get(`/portal/isPhoneNumberInUse`, {
      params: {
        phoneNumber: phoneNumber,
        _: timestamp,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error checking phone number:", error);
    throw error;
  }
};

export const saveUserDetails = async (userData) => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.post(
      `/portal/lean-regn/saveUserDetails?_=${timestamp}`,
      userData
    );
    return response.data;
  } catch (error) {
    console.error("Error saving user details:", error);
    throw error;
  }
};

//add comment for this call
export const updatePhoneNumber = async (phoneNumber) => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.post(
      `/portal/lean-regn/updatePhoneNumber?_=${timestamp}`,
      { phoneNumber }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating phone number:", error);
    throw error;
  }
};

export const verifyLicenseDetails = async (licenseNumber, stateId) => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.get(
      `/portal/verifyLicenseDetails?licenseNumber=${licenseNumber}&stateId=${stateId}&_=${timestamp}`
    );
    return response.data;
  } catch (error) {
    console.error("Error verifying license details:", error);
    throw error;
  }
};

export const insertUserLicense = async (licenseData) => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.post(
      "/portal/user/insertLicense",
      licenseData
    );
    return response.data;
  } catch (error) {
    console.error("Error inserting license:", error);
    throw error;
  }
};

//change Email API's

// 1. Check if email is deleted user's email
export const checkDeletedUserEmail = async (emailId) => {
  try {
    const response = await baseApi.post(
      "/portal/isDeletedUserEmailId",
      emailId
    );
    return response;
  } catch (error) {
    console.error("Error checking deleted user email:", error);
    throw error;
  }
};

// 2. Validate email change
export const validateChangeEmail = async (emailObject) => {
  try {
    const response = await baseApi.post(
      "/portal/lean-regn/validateChangeEmail",
      emailObject
    );
    return response;
  } catch (error) {
    console.error("Error validating email change:", error);
    throw error;
  }
};

// 3. Check if user email is verified
// export const isUserEmailVerified = async (email) => {
//   try {
//     const timestamp = new Date().getTime();
//     const params = new URLSearchParams({
//       email: email,
//       _: timestamp,
//     });
//     const response = await baseApi.get(
//       `/portal/user/isUserEmailVerified?${params}`
//     );
//     return response;
//   } catch (error) {
//     console.error("Error checking email verification:", error);
//     throw error;
//   }
// };

export const isUserEmailVerified = async (email) => {
  try {
    const timestamp = new Date().getTime();
    const payload = {
      email: email,
      _: timestamp,
    };
    const response = await baseApi.post(
      "/portal/user/isUserEmailVerified",
      payload
    );
    return response;
  } catch (error) {
    console.error("Error checking email verification:", error);
    throw error;
  }
};

// 4. Send verification code
export const sendVerificationCode = async (emailData) => {
  try {
    const response = await baseApi.post(
      "/portal/custom/sendVerificationCode",
      emailData
    );
    return response;
  } catch (error) {
    console.error("Error sending verification code:", error);
    throw error;
  }
};

// 5. Send verification code
export const changeEmailId = async (emailData) => {
  try {
    const response = await baseApi.post(
      "/portal/lean-regn/changeEmail",
      emailData
    );
    return response;
  } catch (error) {
    console.error("Error sending verification code:", error);
    throw error;
  }
};

export const getLicenseDetails = async (licenseId) => {
  try {
    const response = await baseApi.get("/portal/user/getLicenseDetails", {
      params: {
        licenseId: licenseId,
        _: new Date().getTime(),
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching license details:", error);
    throw error;
  }
};

export const checkLoginStatus = async () => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.get(`/portal/isLogin?_=${timestamp}`);
    const data = response.data;

    // Sync auth state on every isLogin call
    if (data?.isLoggedOut) {
      store.dispatch(clearAuthData());
      store.dispatch(setAuthenticated(false));
    } else if (data) {
      store.dispatch(setAuthData(data));
    }

    // Flush to localStorage immediately so seller app gets latest state on redirect
    await persistor.flush();

    return data;
  } catch (error) {
    // console.error("Error checking login status:", error);
    throw error;
  }
};
export const getLocation = async () => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.get(`/portal/geoLocation?_=${timestamp}`);
    return response.data;
  } catch (error) {
    // console.error("Error checking login status:", error);
    throw error;
  }
};

//Password Related API's

export const checkValidEmailAddress = async (email) => {
  try {
    const response = await baseApi.post(
      "/portal/user/isValidEmailAddress",
      email
    );
    return response.data;
  } catch (error) {
    console.error("Error checking valid email address:", error);
    throw error;
  }
};

export const getUserSmsOptInDetails = async () => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.get(
      `/portal/lean-regn/getUserSmsOptInDetails?_=${timestamp}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching SMS opt-in details:", error);
    throw error;
  }
};
// api/myProfile.js

export const saveUserSmsOptInFlag = async ({
  phoneNumber,
  smsOptIn,
  endPoint = "saveUserSmsOptInFlag",
}) => {
  try {
    const response = await baseApi.post(`/portal/lean-regn/${endPoint}`, {
      phoneNumber,
      smsOptIn,
    });
    return response.data;
  } catch (error) {
    console.error("Error saving SMS opt-in flag:", error);
    throw error;
  }
};

export const getUserSmsOptInMessage = async () => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.get(
      `/portal/lean-regn/getUserSmsOptInMessage?_=${timestamp}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching SMS opt-in message:", error);
    throw error;
  }
};

export const changePassword = async (passwordData) => {
  try {
    const response = await baseApi.post(
      "/portal/lean-regn/changePassword",
      passwordData
    );
    return response.data;
  } catch (error) {
    console.error("Error changing password:", error);
    throw error;
  }
};

export const updatePassword = async (passwordData) => {
  try {
    const response = await baseApi.post(
      "/portal/lean-regn/updatePassword",
      passwordData
    );
    return response.data;
  } catch (error) {
    console.error("Error changing password:", error);
    throw error;
  }
};

export const deleteUser = async () => {
  try {
    const response = await baseApi.post("/portal/deleteUser");
    return response.data;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};
// Get city list for state
export const getCityListForState = async (state) => {
  try {
    const response = await baseApi.get(`/portal/lean-regn/cityListForState`, {
      params: { state },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Check if SMS feature is enabled
export const checkSmsFeatureEnabled = async (state) => {
  try {
    const response = await baseApi.get(
      `/portal/lean-regn/isSmsFeatureEnabled/${state}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Save buyer profile
export const saveBuyerProfile = async (profileData) => {
  try {
    const response = await baseApi.post(
      `/portal/lean-regn/saveBuyerProfile`,
      profileData
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Check if phone number is in use
export const isPhoneNumberInUse = async (phoneNumber) => {
  try {
    const response = await baseApi.get(`/portal/isPhoneNumberInUse`, {
      params: { phoneNumber },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Check if idology verification is required
export const isIdologyVerificationRequired = async () => {
  try {
    const response = await baseApi.get(
      `/portal/lean-regn/isIdologyVerificationRequired`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get user profile verification details
export const getUserProfileVerificationDetails = async () => {
  try {
    const response = await baseApi.get(
      `/portal/lean-regn/getUserProfileVerificationDetails`,
      {
        params: { timeStamp: Date.now() },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const validateVerificationCode = async (payload) => {
  try {
    const response = await baseApi.post(
      `portal/custom/validateVerificationCode`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error validating code :", error);
    throw error;
  }
};

export const idologyQuestionnaires = async (payload) => {
  try {
    const response = await baseApi.post(
      `portal/idologyQuestionnaires`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error validating code :", error);
    throw error;
  }
};
export const downloadInfo = async () => {
  try {
    const response = await baseApi.post(
      "/portal/printUserDetails",
      {},
      {
        responseType: "blob",
        headers: {
          Accept: "application/pdf",
          "Content-Type": "application/json",
        },
      }
    );
    const { status, data } = response;
    if (status === 200) {
      const blob = new Blob([data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
      setTimeout(() => window.URL.revokeObjectURL(url), 10000);
    } else {
      throw response;
    }
  } catch (error) {
    console.error("Error print user details :", error);
    throw error;
  }
};
export const agentActiveBids = async () => {
  try {
    const response = await baseApi.get(
      `portal/user/isAgentHasActiveBidsAndOffers`,
      {
        params: { timeStamp: Date.now() },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting agent active bids", error);
    throw error;
  }
};
export const sendEmailLink = async () => {
  try {
    const response = await baseApi.get(`/portal/sendIdScanMailToUser`, {
      params: { timeStamp: Date.now() },
    });
    return response.data;
  } catch (error) {
    console.log(error, "Error while sending scan link email");
  }
};

// Upload profile photo
export const uploadProfilePhoto = async (formData) => {
  try {
    const response = await baseApi.post("/portal/uploadUserImage", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error uploading profile photo:", error);
    throw error;
  }
};


// Remove profile photo
export const removeProfilePhoto = async () => {
  try {
    const response = await baseApi.delete("/portal/user/removeProfilePhoto");
    return response.data;
  } catch (error) {
    console.error("Error removing profile photo:", error);
    throw error;
  }
};
// Get profile photo as blob URL
export const getProfilePhotoUrl = async (userId, photoPath) => {
  if (!photoPath || !userId) return null;

  try {
    const filename = photoPath.split('/').pop();
    const response = await baseApi.get(
      `/portal/property/getUserImage/${userId}/${filename}`,
      {
        responseType: 'arraybuffer',
        withCredentials: true,
        headers: {
          'Accept': 'image/*,*/*'
        }
      }
    );
    const base64 = btoa(
      new Uint8Array(response.data)
        .reduce((data, byte) => data + String.fromCharCode(byte), '')
    );

    return `data:image/jpeg;base64,${base64}`;
  } catch (error) {
    console.error('Error fetching profile photo:', error);
    return null;
  }
};